<template>
    <div class="body">
        <div class="h1">
            <van-icon name="checked" color="#22AA75" size="120"/>
        </div>
        <div class="table">
            <!--<p>收款方: 金华市江南中学</p>-->
            <p>账单编号: {{thirdOrderNo}}</p>
            <p>账单金额:{{amount}}</p>
            <p>缴费时间: {{successTime}}</p>
        </div>

        <div class="btns" @click="goBack">
            完 成
        </div>
    </div>
</template>

<script>
    export default {
        name: "billPaySuccess",
        data() {
            return {
                amount: '',
                studentBillDetailId: '',
                successTime:'',
            }
        },
        created() {
            this.amount = this.$route.query.amount
            this.thirdOrderNo = this.$route.query.thirdOrderNo
            this.successTime = this.$route.query.successTime
        },
        methods:{
            goBack(){
                this.$router.push({path: '/studentBill'})
            }
        }
    }
</script>

<style scoped>
    .body{
        width: 100%;
        height: 100%;
        background: white;
    }
    .h1{
        text-align: center;
        padding: 40px 0;
        border-bottom: 2px solid #BBBBBB;
    }
    .table{
        padding:  20px;
    }
    .table p{
        padding: 3px 0;
        color: #999999 ;
        font-size: 14px;
    }

    .btns{
        width: 80%;
        background: #22AA75 ;
        font-size: 16px;
        text-align: center;
        color: white;
        margin: 40px auto;
        height: 46px;
        line-height: 46px;
        border-radius: 5px;
    }
</style>
